import controller from './chart-desk-occupancy-agg.controller';
import { bindings } from '../chart-abstract-base';
import template from './template.html';

export default {
    bindings: {
        ...bindings,
        onChartSelection: '&',
        onChartPan: '&',
        extremes: '<',
    },
    template,
    controller
};
